import axiosInstance from "services/common/axiosInstance";

const handleRequest = async <T>(promise: Promise<any>): Promise<T> => {
  try {
    const response = await promise;
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error.message;
  }
};

const BASE_URL = "/reports";

export interface Transaction {
  id: number;
  txn_datetime: string;
  phone_no: string;
  email: string;
  username: string;
  category_name: string;
  paymentmethodname: string;
  accountname: string;
  currencycode: string;
  currencysymbol: string;
  transactiontype: string;
  transactionoption: string;
  frequency: string;
  paymentsuboption: string;
  amount: number;
  created_at: string;
  updated_at: string | null;
}

export interface Pagination {
  page: number;
  per_page: number;
  total_pages: number;
  total_items: number;
}

export interface TransactionListResponse {
  message: string;
  data: {
    transactions: Transaction[];
    pagination: Pagination;
  };
  success: boolean;
}

export interface GetTransactionListParams {
  from_date: string;
  to_date: string;
  paymentmethodname: string;
  category_name: string;
  frequency: string;
  searchkey: string;
  accountname: string;
  phone_no: string;
  transaction_type?: string;
  page: number;
  page_size: number;
}

export const listAllTransactionReport = (
  data: GetTransactionListParams
) =>
  handleRequest<TransactionListResponse>(
    axiosInstance.post(`${BASE_URL}/listalltransactionreport`, data)
  );

export interface Contributor {
  memberid: number;
  amount: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  relationship_name: string;
  email: string;
  phone_no: string;
  payment_method_id: number;
  payment_method_name: string | null;
  createdon: string;
}

export interface GraphSummary {
  memberid: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  total_contribution: number;
  total_count: number;
}

export interface GoalDetail {
  goalid: number;
  famillyid: number;
  userid: number;
  goalname: string;
  goalcategory: string;
  targetamount: number;
  currentsaving: number;
  targetdate: string;
  frequencysaving: string;
  notes: string;
  goal_status: string;
  category_name: string;
  subcategoryid: number;
  categoryid: number;
  subcategory: string;
  timehorizon: string;
  transactiontype: string | null;
  iteamtype: string | null;
  createdby: number;
  contributor: Contributor[];
  graph_summary: GraphSummary[];
}

export interface FamilyDetail {
  id: number;
  user_id: number;
  phone_no: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  relationship_name: string;
  occupation: string;
  dob: string;
  email: string;
  isblocked: boolean;
  famillyid: number;
  goal_detail: GoalDetail[];
}

export interface FamilyDetailListResponse {
  message: string;
  data: {
    familydetails: FamilyDetail[];
    pagination: Pagination;
  };
  success: boolean;
}

export interface GetFamilyDetailListParams {
  familyid: number;
  phone_no: string;
  email: string;
  page: number;
  page_size: number;
}

export const listFamilyDetailReport = (
  data: GetFamilyDetailListParams
) =>
  handleRequest<FamilyDetailListResponse>(
    axiosInstance.post(`${BASE_URL}/listfamilydetailreport`, data)
  );


